var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loadingDialog" }, [
    _c("svg", { attrs: { viewBox: "0 0 32 32", width: "64", height: "64" } }, [
      _c("circle", {
        staticClass: "dialogSpinner",
        attrs: { cx: "16", cy: "16", r: "14", fill: "none" },
      }),
    ]),
    _c("span", { staticClass: "loaderText", style: { color: _vm.textColor } }, [
      _vm._v(_vm._s(_vm.content)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }